// imports
import Accordion from 'minsky-kit/js/components/Accordion';

// private statics

// class definition
export default class WADAccordion extends Accordion {
    // constructor
    constructor (args = {}, objectName = 'Accordion') {
        args.debug = args.debug || false;
        args.preventDefault = true;

        // super
        super(args, objectName);
    }

    // methods

    destroy () {
        super.destroy();
    }

    // getters & setters
}

// Utils

// Event handlers
